import { RotateCcw } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { ReturnsRmaPage } from './pages/ReturnsRmaPage'

/**
 * Returns / RMA — v1 (2026-07-23).
 *
 * Issues RMA numbers + Return Authorization documentation for material
 * coming back from customers, and tracks the return through to
 * resolution. Odoo interaction is read-only in v1 (customer/product
 * lookups) — actual stock reversal (stock.return.picking) and credit
 * memos stay manual Odoo steps. No automated customer-facing email:
 * ops staff download the generated PDF and send it themselves.
 *
 * Entry point is manual creation in this module only — no CARLA chat
 * tool, no Support Command Center linkage in v1.
 */
export default defineModule({
  id: 'returns-rma',
  name: 'Returns / RMA',
  shortName: 'Returns',
  icon: RotateCcw,
  navSection: 'sales',
  navOrder: 6,
  urlNamespace: '/returns-rma',
  routes: [{ path: '/', element: ReturnsRmaPage, label: 'Returns / RMA' }],
  permissions: ['admin', 'sales', 'operations', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g r m',

  commandPaletteEntries: [
    {
      label: 'Go to Returns / RMA',
      keywords: ['rma', 'return', 'returns', 'authorization', 'credit'],
      path: '/',
      group: 'modules',
      shortcut: 'g r m',
    },
    {
      label: 'New RMA',
      keywords: ['new rma', 'return authorization', 'create return'],
      path: '/?action=new',
      group: 'actions',
    },
  ],
})
